const features = [
  {
    title: 'TreeVault Cloud',
    description:
      'Keep automatic backups and device sync in one place so your research survives hardware changes.',
  },
  {
    title: 'Charts & Reports',
    description:
      'Build pedigree, descendant, and fan charts with polished layouts ready to print or share.',
  },
  {
    title: 'Media Library',
    description:
      'Link photos, scans, and audio clips to individuals and pull them up instantly when you need them.',
  },
  {
    title: 'Smart Matching',
    description:
      'Color tags and duplicate alerts make it easier to merge records without losing detail.',
  },
  {
    title: 'FamilySync Hints',
    description:
      'Connect to FamilySearch and review suggested ancestor matches that expand your tree.',
  },
  {
    title: 'FamilySearch Tools',
    description:
      'Search, attach, and confirm records from inside Family Tree Maker as new tools roll out.',
  },
];

export default function Features() {
  return (
    <section className="t7-section t7-section--white" id="about">
      <div className="container">
        <div className="t7-head t7-head--rail">
          <p className="t7-kicker">Inside the software</p>
          <h2 className="t7-title">Built for serious family historians</h2>
          <p className="t7-lead">
            Family Tree Maker pairs a familiar workspace with powerful research tools—so you can
            grow from a handful of names to a multi-generation archive without starting over.
          </p>
        </div>

        <div className="t7-features-grid">
          {features.map((feature, index) => (
            <article key={feature.title} className="t7-feature-cell group">
              <span className="block text-xs font-bold tracking-[0.16em] text-[#40916c] mb-2 sm:mb-3">
                {String(index + 1).padStart(2, '0')}
              </span>
              <h3 className="font-serif text-lg sm:text-xl text-[#152019] mb-2 sm:mb-3 group-hover:text-[#2d6a4f] transition-colors">
                {feature.title}
              </h3>
              <p className="text-[#55665c] text-sm sm:text-[15px] leading-relaxed m-0">
                {feature.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
